import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import RoomsAndStudents from '../RoomsAndStudents';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import Quiz from '../Quiz/Quiz';
import StudentAnswerQuiz from '../StudentAnswerQuiz';

class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.dashboard)
        }}
      >{formatMessage('navTitleDashboard')}</MenuItem>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.statistic_reports)
        }}
      >{formatMessage('dashStatisticReports')}</MenuItem>
   </React.Fragment>
  }
}

const StudentAnswerQuizPage = (props) => {
  return <Wrapper 
    renderButtonNav = {false}
    CustomItems={CustomItems}
  >
    <StudentAnswerQuiz {...props} />
  </Wrapper>
}

export default StudentAnswerQuizPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/StudentAnswerQuizPage.js